import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { SectionLabel } from "@/components/Shared";

export function Newsletter() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { name, email, category });
      toast.success(data.message);
      setName(""); setEmail(""); setCategory("");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-navy grain relative overflow-hidden" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionLabel light>The KRV Prime Market Brief</SectionLabel>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white leading-tight">
              Get every new post delivered to your inbox.
            </h2>
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-md">
              Subscribe and we'll email you the moment a new market analysis or research post goes live —
              the headline, a short summary and a direct link. No hype, no tips, just systematic thinking. Unsubscribe anytime.
            </p>
          </div>
          <form onSubmit={submit} className="bg-white/5 border border-white/10 rounded-lg p-6 backdrop-blur-sm" data-testid="newsletter-form">
            <div className="grid sm:grid-cols-2 gap-3">
              <input
                required value={name} onChange={(e) => setName(e.target.value)}
                data-testid="newsletter-name" placeholder="Your name"
                className="bg-white/5 border border-white/15 rounded-md px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-gold"
              />
              <select
                value={category} onChange={(e) => setCategory(e.target.value)}
                data-testid="newsletter-category"
                className="bg-white/5 border border-white/15 rounded-md px-4 py-3 text-sm text-white outline-none focus:ring-2 focus:ring-gold"
              >
                <option value="" className="bg-navy">Category (optional)</option>
                <option value="professional" className="bg-navy">Working Professional</option>
                <option value="student" className="bg-navy">Student</option>
                <option value="trader" className="bg-navy">Trader / Investor</option>
              </select>
            </div>
            <input
              required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="newsletter-email" placeholder="Email address"
              className="w-full mt-3 bg-white/5 border border-white/15 rounded-md px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-gold"
            />
            <button
              type="submit" disabled={loading} data-testid="newsletter-submit"
              className="w-full mt-3 inline-flex items-center justify-center gap-2 h-11 rounded-md bg-gold text-navy font-semibold text-sm hover:bg-gold-soft transition-colors disabled:opacity-60"
            >
              {loading ? "Subscribing…" : "Subscribe"} <Send className="h-4 w-4" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
